import React from 'react'
import styled from 'styled-components'
import TooltipWrapper from '../../../../../components/TooltipWrapper'

interface ICheckboxProps {
    checkboxState?: boolean | string
    onClick?: (e: React.MouseEvent) => void
    tooltip?: string
}

const Checkbox: React.FC<ICheckboxProps> = ({ checkboxState, onClick, tooltip }) => {
    const isIndeterminate = checkboxState === 'ind'
    const isChecked = checkboxState === true

    const checkbox = (
        <Container onClick={onClick}>
            <StyledCheckbox checked={isChecked} indeterminate={isIndeterminate}>
                {isIndeterminate && <Line />}
                {isChecked && (
                    <svg width="10" height="8" viewBox="0 0 10 8" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 4l3 3 5-6" stroke="white" strokeWidth="1.5" fill="none" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                )}
            </StyledCheckbox>
        </Container>
    )

    if (!tooltip) return checkbox

    return (
        <TooltipWrapper tooltipText={tooltip} placement="top">
            {checkbox}
        </TooltipWrapper>
    )
}

const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    cursor: pointer;
`

const StyledCheckbox = styled.div<{ checked: boolean; indeterminate: boolean }>`
    width: 16px;
    height: 16px;
    border-radius: 3px;
    border: 1.5px solid ${props => (props.checked || props.indeterminate) ? '#5964ff' : '#b8bfcf'};
    background-color: ${props => (props.checked || props.indeterminate) ? '#5964ff' : 'transparent'};
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.15s ease;
    flex-shrink: 0;

    &:hover {
        border-color: #5964ff;
    }
`

const Line = styled.div`
    width: 8px;
    height: 2px;
    background-color: white;
    border-radius: 1px;
`

export default Checkbox
